import { render } from "./DepositTransferHistory.vue?vue&type=template&id=4c6c1068&scoped=true&ts=true"
import script from "./DepositTransferHistory.vue?vue&type=script&lang=ts"
export * from "./DepositTransferHistory.vue?vue&type=script&lang=ts"

import "./DepositTransferHistory.vue?vue&type=style&index=0&id=4c6c1068&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6c1068"]])

export default __exports__